"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CounterTag = CounterTag;
var React = _interopRequireWildcard(require("react"));
var _common = require("../../common");
var _IndicatorTag = require("./IndicatorTag");
var _Tag = require("./Tag");
var _excluded = ["count", "interactive", "minimal", "outlineOnEmpty", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function CounterTag(_ref) {
  var count = _ref.count,
    interactive = _ref.interactive,
    minimal = _ref.minimal,
    _ref$outlineOnEmpty = _ref.outlineOnEmpty,
    outlineOnEmpty = _ref$outlineOnEmpty === void 0 ? false : _ref$outlineOnEmpty,
    style = _ref.style,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  var isCountInteger = Number.isInteger(count);
  var isCountPositiveInteger = isCountInteger && count && count > 0;

  /**
   * We only want to show the visible count indicator tag if
   */
  var hasVisibleCountIndicator = true;
  var shouldOutline = outlineOnEmpty && !isCountPositiveInteger;
  if (shouldOutline) {
    hasVisibleCountIndicator = false;
  }

  /**
   * The indicator tag that contains the count needs to be white for minimal tags,
   * and the same color as the tag (but minimal) for filled tags.
   */
  var indicatorTagProps = {
    minimal: !minimal,
    colorFamily: minimal ? _common.ColorFamily.WHITE : passThroughProps.colorFamily
  };
  var indicatorTag = /*#__PURE__*/React.createElement(_IndicatorTag.IndicatorTag, indicatorTagProps, count);

  /**
   * We can't easily put the styles in the CSS as we modify whether the count indicator is visible
   * to bring the IndicatorTag closer to the edge of the tag
   */
  var tagProps = {
    interactive: interactive,
    round: true,
    large: true,
    muted: true,
    style: _objectSpread(_objectSpread({}, style), hasVisibleCountIndicator && {
      paddingRight: '4px'
    }),
    rightIcon: hasVisibleCountIndicator ? indicatorTag : undefined
  };
  if (shouldOutline) {
    tagProps.outline = true;
  } else {
    tagProps.minimal = minimal;
  }
  return /*#__PURE__*/React.createElement(_Tag.Tag, _extends({}, passThroughProps, tagProps));
}